import React from "react";
import { Icon } from "@/components/Icon";

/**
 * Shared "couldn't load — retry" block (UIA-02). Distinct from a genuine empty state:
 * an empty state means the request succeeded and returned nothing; this means the
 * request FAILED and the player can retry. Matches the dark design system
 * (#0A0A0A / single green #00D632 / red #EF4444, Manrope/Outfit).
 */
export default function LoadError({ onRetry, message = "We couldn't load this right now.", testid = "load-error" }) {
  return (
    <div
      className="flex flex-col items-center gap-3 rounded-2xl border border-[#27272A] bg-[#141417] py-12 text-center"
      data-testid={testid}
    >
      <Icon name="alert-circle" size={28} className="text-[#EF4444]" />
      <div>
        <p className="font-display text-base font-black text-white">Couldn&apos;t load</p>
        <p className="mt-1 text-sm text-[#a1a1aa]">{message}</p>
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          data-testid={`${testid}-retry`}
          className="inline-flex items-center gap-2 rounded-full bg-[#00D632] px-5 py-2.5 text-sm font-bold text-[#0A0A0A] transition-colors hover:bg-[#00B829]"
        >
          <Icon name="refresh" size={15} /> Retry
        </button>
      )}
    </div>
  );
}
